/**
 * Warnt, wenn für einen Channel kein bullet_mapping konfiguriert ist und der
 * Nutzer "bullets" als Texttyp wählt — die generierten Bullets würden sonst
 * nie nach JTL gepusht (Spec 2026-07-24 §7, Folge-Task aus Task-11-Review).
 * Best-effort: schlägt der Read fehl, wird keine Warnung gezeigt (blockiert nicht).
 */
import { useQuery } from '@tanstack/react-query'

import { useChannels } from '@/hooks/useChannels'
import { getBulletMappings, type BulletMapping } from '@/lib/api/integrations-bullet-mapping'

const BULLET_KEYS = ['bullet_1', 'bullet_2', 'bullet_3', 'bullet_4', 'bullet_5'] as const

function hasBulletSlot(mapping: BulletMapping | undefined): boolean {
  if (!mapping) return false
  return BULLET_KEYS.some((key) => Boolean(mapping[key]))
}

export function useBulletMappingWarning(channelId: string): { missing: boolean } {
  const { data: channels = [] } = useChannels()
  const channel = channels.find((c) => c.id === channelId)
  const integrationId = channel?.workspace_integration_id

  const { data, isSuccess } = useQuery({
    queryKey: ['bullet-mapping', integrationId],
    queryFn: () => getBulletMappings(integrationId as string),
    enabled: Boolean(integrationId),
  })

  if (!channel?.channel_id || !integrationId || !isSuccess) return { missing: false }
  return { missing: !hasBulletSlot(data!.bullet_mapping[channel.channel_id]) }
}
